<template>
  <div
    class="search-form nopads"
    style="height: 35vh; overflow: hidden"
  >
    <span class="report-title text-center nopads">{{ title }}</span>
    <bar-chart
        v-if="chartData.length"
        ref="observationValues"
        class="routa-bars"
        :labels="labels"
        :colors="colors"
        :data="chartData"
        :upper-limit="upperLimit"
        :lower-limit="lowerLimit"
        :title="title"
        @on-bar-click="handleBarClick"
    />
  </div>
</template>

<script>
import BarChart from '../../chart/BarChart'
import {timeUtils} from "../../mixins/TimeUtils";

export default {
    name: 'ObservationValueCharts',
    components: {BarChart},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        upperLimit: {
            type: Number,
            default: null
        },
        lowerLimit: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            labels: [],
            colors: [],
            chartData: []
        }
    },
    watch: {
        results() {
            this.formatData()
        },
    },
    mounted: function () {
        this.formatData()
    },
    methods: {
        formatData: function () {
            this.results.forEach(item =>  {
                this.chartData.push({value: item.value})
                this.labels.push(this.toLocalTime(item.created_time))
                this.colors.push(this.beyondLimit(item.value) ? '#bd7c7c' : '#81a464')
            })
        },
        beyondLimit(value) {
            return (this.upperLimit && value > this.upperLimit) || (this.lowerLimit && value < this.lowerLimit)
        },
        handleBarClick(index) {
            this.$emit('itemClicked', index)
        },
        setSelected(index) {
            this.$refs.observationValues.setSelected(index)
        }
    }
}
</script>
<style>
</style>
